import { type ComponentProps } from 'react';
import { PreAuthHeader } from '@hungryroot/app-public';
import { islandRoot } from '../IslandRoot/IslandRoot';

export const PreAuthHeaderIsland = islandRoot(
  (props: ComponentProps<typeof PreAuthHeader>) => {
    return <PreAuthHeader {...props} />;
  }
);
